import http from "core/services/http";
import Config from "core/config";
import { isObject } from "lodash";
import { toQueryString } from "shared/helpers";

export default class StaticService {
  static getRaces() {
    return http.get(`${Config.apiUrl}/races`);
  }

  static getRoles() {
    return http.get(`${Config.apiUrl}/roles`);
  }

  static getGenders() {
    return http.get(`${Config.apiUrl}/gender`);
  }

  static getHispanicTypes() {
    return http.get(`${Config.apiUrl}/hispanictypes`);
  }

  static getInstitutionTypes() {
    return http.get(`${Config.apiUrl}/testcentertypes`);
  }

  static getSecurityQuestions() {
    return http.get(`${Config.apiUrl}/securityquestions`);
  }

  static getCapacityTypes(cycleId) {
    return http.get(`${Config.apiUrl}/capacitytypes?cycleId=${cycleId}`);
  }

  static getTestingEvents() {
    return http.get(`${Config.apiUrl}/testingevents`);
  }

  static getIrregularityCategories() {
    return http.get(`${Config.apiUrl}/irregularitycategories`);
  }

  static getIrregularityTypes(params) {
    const queryString =
      params && isObject(params) ? `?${toQueryString(params)}` : "";
    return http.get(`${Config.apiUrl}/irregularitytypes${queryString}`);
  }

  static getIrregularityStages({ programId }) {
    return http.get(`${Config.apiUrl}/stages?programId=${programId}`);
  }

  static getPermissions() {
    return http.get(`${Config.apiUrl}/permissions`);
  }

  static getRoomTypes(testCenterEventId) {
    return http.get(
      `${Config.apiUrl}/query/roomTypeTiming?testCenterEventId=${testCenterEventId}`
    );
  }

  static getEmailSubjects() {
    return http.get(`${Config.apiUrl}/subjects`);
  }

  static getDisplayTexts(cycleId) {
    return http.get(`${Config.apiUrl}/displaytexts?cycleId=${cycleId}`);
  }

  static getServerDateTime() {
    return http.get(`${Config.apiUrl}/serverdatetime`);
  }

  static getRoomTiming() {
    return http.get(`${Config.apiUrl}/query/timing`);
  }

  static getRegTypes(cycleId) {
    return http.get(`${Config.apiUrl}/query/regTypes?cycleId=${cycleId}`);
  }
}
